import React from 'react';

export const Logo = ({ className = "", variant = "default", showText = true, size = "default" }) => {
  // Text-only variant (pour footer par exemple)
  if (variant === "text-only") {
    return (
      <div className={`font-bold ${className}`}>
        <span className="text-green-600">AGIPLUS</span>
        <span className="text-orange-500"> CI</span>
      </div>
    );
  }

  // Définir les tailles selon le contexte
  const sizes = {
    small: { height: '40px', fontSize: 'text-lg' },
    default: { height: '60px', fontSize: 'text-2xl' },
    large: { height: '80px', fontSize: 'text-3xl' }
  };

  const currentSize = sizes[size] || sizes.default;

  // Logo image avec texte à côté
  return (
    <div className={`flex items-center gap-2 md:gap-3 ${className}`}>
      <img 
        src="/logo-agiplus.png" 
        alt="AGIPLUS CI - Solutions Hydrauliques & Techniques" 
        className="object-contain h-10 md:h-14 lg:h-16"
        style={{ width: 'auto' }}
      />
      {showText && (
        <div className="font-bold text-xl md:text-2xl lg:text-3xl leading-tight">
          <span className="text-green-600">AGIPLUS</span>
          <span className="text-orange-500"> CI</span>
        </div>
      )}
    </div>
  );
};
